import { useContext, useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { AuthContext } from "../../../services/authContext";

const EditProfile = ({ show, handleClose }) => {
    const { userProfile, updateUserProfile } = useContext(AuthContext);
    const [editProfile, setEditProfile] = useState(userProfile || {});
    useEffect(() => {
        setEditProfile(userProfile || {});
    }, [userProfile]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setEditProfile((prev) => ({
            ...prev,
            [name]: value, // Update only profile fields
        }));
    };

    const handleSave = () => {
        if (!userProfile) return;
        const patchData = [];
        const fields = ["firstName", "familyName", "nickname"];

        fields.forEach((field) => {
            const oldValue = userProfile[field] || "";
            const newValue = editProfile[field] || "";

            if (oldValue !== newValue) {
                patchData.push({
                    type: "replace",
                    path: `${field}`,
                    value: newValue,
                });
            }
        });

        if (patchData.length > 0) {
            updateUserProfile(patchData);
        }

        handleClose();
    };
    return (
        <Modal show={show} onHide={handleClose}>
            <div className="component p-0 m-0 rounded">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>First name</Form.Label>
                            <Form.Control
                                type="text"
                                name="firstName"
                                value={editProfile.firstName || ""}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Family name</Form.Label>
                            <Form.Control
                                type="text"
                                name="familyName"
                                value={editProfile.familyName || ""}
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Nickname</Form.Label>
                            <Form.Control
                                type="text"
                                name="nickname"
                                value={editProfile.nickname || ""}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Update Profile
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
};

export default EditProfile;
